export const keyCodes = {
  TAB: 9,
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
  UP: 38,
  DOWN: 40,
};
